<template>
  <div>

    <side-bar id="sidebar" type="sidebar" :sidebar-links="$sidebar.sidebarLinks" :sidebar-links-mobile="$sidebar.sidebarLinksMobile">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar id="navbar"></top-navbar>

      <dashboard-content id="content">

      </dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  // import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import {SettingsService} from '../../../services/storage.service'
  import { mapState } from "vuex"

  export default {
    computed: {
      sidebarMini () {
        return this.$store.getters.getSidebarMini
      }
    },
    created() {
      this.displaySidebar = SettingsService.getSidebarSettings()
      if (this.displaySidebar == true) {
        this.$sidebar.toggleMinimize()
      }
    },
    watch: {
      sidebarMini() {
          this.$sidebar.toggleMinimize()
      }
    },
    mounted() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    components: {
      TopNavbar,
      // ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      handleResize() {
        let navbarHeight = document.getElementById("navbar").offsetHeight
        let contentHeight = window.offsetHeight - navbarHeight
        document.getElementById("content").style.height = contentHeight + 'px'
        document.getElementById("content").style.marginTop = navbarHeight + 'px'
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
<style>
</style>
